<template>
  <div class="containers">
    <div class="container">

     
      <main class="main-content" v-if="isHome">
        <div class="news-list">
          <div class="news-item" v-for="(item, index) in newsList" :key="index">
            <div class="newsbotton">
              <div class="news-number">{{ index + 1 }}</div>
              <div class="news-date">{{ item.updateTime }}</div>
            </div>
            <div class="news-text">
              <el-tooltip
                :content="item.supplierName"
                placement="top"
                effect="dark"
                :open-delay="500"
              >
                <p>
                  {{
                    item.supplierName.length > 20
                      ? item.supplierName.slice(0, 20) + "..."
                      : item.supplierName
                  }}
                </p>
              </el-tooltip>
              <!-- <p>{{ item.content }}</p> -->
              <span
                @click="showDetails(index)"
                class="newbuttons"
                :class="{ 'cursor-pointer': true }"
                >查看更多→</span
              >
              <!-- <a href="#">查看更多→</a> -->
            </div>
          </div>
        </div>
      </main>

      <div v-if="selectedItem" class="details-modal">
        <div class="details-content">
          <P class="kk" @click="closeDetails">x</P>
          <h2>资讯详情</h2>

          <p>
            <span class="gray-text">产品名称：</span>
            <span class="black-text">{{ selectedItem.productName }}</span>
          </p>
          <p>
            <span class="gray-text">产品介绍：</span>
            <span class="black-text">{{
              selectedItem.productDescription
            }}</span>
          </p>
          <p>
            <span class="gray-text">应用领域：</span>
            <span class="black-text">{{ selectedItem.applicationArea }}</span>
          </p>
          <p>
            <span class="gray-text">买方：</span>
            <span class="black-text">{{ selectedItem.buyerName }}</span>
          </p>
          <!-- <p>
          <span class="gray-text">买方行业：</span>
          <span class="black-text">{{ selectedItem.buyerIndustry }}</span>
        </p> -->
          <p>
            <span class="gray-text">融资方式：</span>
            <span class="black-text">{{ selectedItem.financingWay }}</span>
          </p>
          <p>
            <span class="gray-text">融资金额：</span>
            <span class="black-text">{{ selectedItem.financingAmount }}</span>
          </p>
          <p>
            <span class="gray-text">估值金额：</span>
            <span class="black-text">{{ selectedItem.appRaiseMenT }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="logo">
        <img src="@/assets/img/home/biglogo.png" alt="Logo" />

        <div class="contact">
          <p>企业邮箱：<span class="email">kefu@iprobeinfo.com</span></p>
          <p>联系电话：021-60833218</p>
          <p>公司地址：上海市闵行区浦江镇陈行公路<br />2388号2号楼5楼东座</p>
        </div>
        <div class="footer-links">
          <div class="link-column">
            <a href="https://www.hittik.com/home">首页</a>
            <a>关于我们</a>
          </div>
          <div class="link-column">
            <a @click="getpdfListData">网站声明</a>
            <a>收藏本站</a>
          </div>
        </div>
      </div>
      <!-- <div class="wechat">
        <img src="@/assets/img/gongzhonghao.png" alt="QR Code 1" />
        <span class="wechat-text">微信公众号</span>
      </div> -->
      <!-- <div class="qr-codes">
        <img src="path/to/your/qrcode1.png" alt="QR Code 1" />
        <img src="path/to/your/qrcode2.png" alt="QR Code 2" />
      </div> -->
      <div class="copyright">
        <a  style="text-decoration: none; font-size: large; color: #ffff;">
          版权所有 © 2024-2025 上海元卓信息科技有限公司
          <!-- <a href="http://www.datasmartbrain.com">www.datasmartbrain.com</a> -->
          沪ICP备17053319号-2
        </a>
      </div>
    </div>
    <el-dialog :visible.sync="pdfDialogVisible" title="网站声明" width="80%">
      <!-- 使用 iframe 嵌入 PDF 文件 -->
      <iframe
        v-if="pdfDialogVisible"
        :src="pdfUrl"
        width="100%"
        height="650px"
        frameborder="0"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "App",

  data() {
    return {
      showDetailsFlags: false, // 控制详情显示
      showDetailsFlag: false, // 控制详情显示
      selectedItem: null, // 当前选中的详细信息
      pdfDialogVisible: false, // 控制弹框显示
      pdfUrl: "", // PDF 文件的 URL
      newsList: [],
      isHome: false,
    };
  },
  methods: {
    async getpdfListData() {
      this.pdfDialogVisible = true;
      // const token = localStorage.getItem("token");
      // let config = {};
      // if (token) {
      //   config = {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //     },
      //   };
      // }

       this.$api
                .getTitle()
                .then((responses) => {
                  if (responses) {
                    //console.log(response.data);
                    const newdata = responses;
      this.pdfUrl = this.extractUrls(newdata.websiteStatement);
                  }
                });
      // const res = await this.axios.get(
      //   "https://www.hittik.com/zntop/top/getTitle",
      //   config
      // );
      
    },
    extractUrls(images) {
      return images.map((img) => {
        const urlMatch = img.match(/<url.*?>(.*?)<\/url>/);
        return urlMatch ? urlMatch[1].trim() : img;
      });
    },
    truncatedUpdateTime(time) {
      return time.length > 24 ? time.slice(0, 24) + "..." : time;
    },

    showDetails(index) {
      // const token = localStorage.getItem("token");
      // // console.log(token);

      // if (token == null) {
      //   this.showDetailsFlags = false;
      //   this.showDetailsFlags = true;
      //   this.$store.commit("setDialogVisible", true);
      // } else {
      this.showDetailsFlags = false;
      this.selectedItem = this.newsList[index];
      // }
      // alert( this.showDetailsFlags );

      // this.showDetailsFlags = !this.showDetailsFlags;
    },
    closeDetails() {
      this.selectedItem = null;
    },
    async getCardListData() {
     
      // const res = await this.axios.get(
      //   "https://www.hittik.com/zntop/top/getInformation",
      //   config
      // );

       this.$api
                .getInformation()
                .then((responses) => {
                  if (responses) {
                    //console.log(response.data);
                    this.newsList = responses;
                  }
                });
     
      
    },
    someHomeMethod() {
      this.showDetails("index");
      console.log("调用了 Home 页面的方法");
      // 在这里执行你需要的操作
    },
  },
created() {
    // 判断当前路由是否是 home 页面
    console.log(this.$route.path);
    
    this.isHome = this.$route.path === '/home';
  },
  watch: {
    // 如果路由发生变化，再次判断
    '$route'(to) {
      this.isHome = to.path === '/home';
    }
  },
  mounted() {
    this.getCardListData();
    this.$root.$on("callHomeMethod", this.someHomeMethod);
  },
  beforeDestroy() {
    this.$root.$off("callHomeMethod", this.someHomeMethod);
  },
};
</script>

<style scoped>
.container {
  width: 66%;

  margin: 0 auto;
  font-family: Arial, sans-serif;
}
.containers {
  width: 100%;

  margin: 0 auto;
  font-family: Arial, sans-serif;
}

.header {
  background-color: #ffffff;
  padding: 10px 0;
  text-align: center;
}

.header nav a {
  margin: 0 10px;
  text-decoration: none;
  color: #333;
}

.main-content {
  padding: 20px 0;
}

.details-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.details-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 60%;
  max-width: 800px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: left;
}

.details-content h2 {
  margin-top: 0;
  font-size: 24px;
  color: #333;
}
.kk {
  float: right;
  width: 20px;
  height: 20px;
}

.details-content p {
  font-size: 16px;
  margin: 10px 0;
}

.details-content button {
  background-color: #2fabf0;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.details-content button:hover {
  background-color: #2f8df0;
}

.gray-text {
  color: #888; /* 灰色 */
}

.black-text {
  color: #333; /* 黑色 */
}

.news-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.newsbotton {
  display: flex;
  flex-direction: column;
  width: 10%;
  height: 10%;
  /* display: flex;
    flex-direction: column; */
}
.news-item {
  width: calc(50% - 20px);
  margin-bottom: 20px;
  padding: 10px;
  display: flex;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.news-number {
  font-family: Alimama ShuHeiTi;
  font-weight: 700;
  font-size: 24px;
  line-height: 28.8px;
  letter-spacing: 0%;
  text-align: center;
  color: #073973;

  margin-bottom: 10px;
}

.news-text h4 {
  font-size: 18px;
  margin: 0 0 10px;
}

.news-text p {
  color: #000;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0%;
}

.newbuttons {
  /* 鼠标悬停效果 *
  transition: transform 0.3s ease;
}

.newbuttons:hover {
  transform: scale(1.1); /* 鼠标悬停时放大 */
  cursor: pointer;
}
.news-text .newbuttons {
  text-decoration: none;

  color: #2f8df0;
  display: flex;
  margin: 11px 0px 0px 9px;
}

/* .footer {
  background-color: #ffffff;
  padding: 10px 0;
  text-align: center;
} */

.footer {
  background: linear-gradient(180deg, #2984eb 0%, #123182 100%);
  display: flex;
  flex-direction: column;
  /* background-color: #0a47aa; */
  color: #fff;
  padding: 20px;
  text-align: center;
  height: 360px;
  font-family: Arial, sans-serif;
}
.info {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  margin-bottom: 116px;
  padding-left: 258px;
}
.logo {
  display: flex;
  margin-left: -945px;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  margin-bottom: 116px;
}
.logo img {
  width: 300px;
  height: 45px;
}

.contact {
  text-align: left;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  line-height: 42px;
  letter-spacing: 0%;
}
::v-deep.iframe::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 禁用鼠标交互 */
}
.email {
}
.links a {
  color: #fff;
  text-decoration: none;
  margin: 0 10px;
}
.wechat {
  margin-top: -271px;
  margin-left: 1045px;
  position: relative;
}
.wechat-text {
  /* margin-right: 77px; */
  margin-left: -115px;
  /* position: relative; */
  margin-top: 150px;
  position: absolute;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0%;
}
.links {
  display: flex;
  margin-left: 1567px;
  /* justify-content: space-between; */
  width: 500px;
  /* height: 40px; */
  flex-direction: row;
}
.footer-links {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  line-height: 42px;
  letter-spacing: 0%;

  display: flex;
  justify-content: space-between;
  color: #fff;
  padding: 1.04167vw 0;
  width: 19%;
  margin-left: 51%;
  margin-top: -6%;
}

.link-column {
  display: flex;
  flex-direction: column; /* 列方向 */
}

.link-column a {
  margin: 5px 0; /* 链接之间的外边距 */
  color: #fff; /* 链接颜色 */
  text-decoration: none; /* 去掉下划线 */
}

.link-column a:hover {
  text-decoration: underline; /* 鼠标悬停时下划线 */
}
.qr-codes img {
  width: 100px;
  height: 100px;
  margin: 0 10px;
}
.copyright {
  border-bottom: 1px solid #fff;
  margin-top: -18px;
}
</style>
